/**
 *
 * URL constants
 */

// SDK URLs:
export const TAPPAY_SDK_TPDIRECT = "https://js.tappaysdk.com/tpdirect/v5.13.1";
export const GOOGLE_PAY_SDK = "https://pay.google.com/gp/p/js/pay.js";